import {useParams} from "react-router-dom";
import styled from "styled-components";
import {useBaseCommunity, useRelativeTime} from '../../store';
import {WhiteMain} from '../../components/main';
import {FixedTopBar} from '../../components/top_bar';
import useFeedback from "../../utils/use_feedback";
import {useQuery} from "../../utils/router";
import {useBans} from "../../api/moderation";
import {themecolors} from "../../utils/themecolors";
import Pagination from "../../components/pagination";
import React, {useState} from "react";
import Sheet from "../../components/bottom-sheet/sheet";
import UnbanSheet from "../../components/bottom-sheet/mod/unban";

const Info = styled.div``;
const Author = styled.span``;
const Ago = styled.span``;
const Moderator = styled.div``;

const BanEntry = styled(({className, ban, onClick}) => {
    const ago = useRelativeTime(ban.created, false);
    return (
        <div className={className} onClick={onClick}>
            <Info>
                <Author>{ban.author}</Author>
                <Ago>{ago} ago</Ago>
            </Info>
            <Moderator>banned by {ban.moderator}</Moderator>
        </div>
    )
})`
  padding: 16px 24px;

  ${Info} {
    display: flex;
    align-items: center;
  }

  ${Author} {
    font-weight: 600;
    font-size: 15px;
  }

  ${Moderator} {
    font-size: 14px;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
  }

  ${Ago} {
    font-size: 13px;
    margin-left: auto;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_low_impact_text};
  }
`;

const Ban = styled(({className}) => {

    const {error, feedbackCh} = useFeedback();
    const baseCommunity = useBaseCommunity();
    const {community: paramsCommunity} = useParams();
    const community = (paramsCommunity || baseCommunity).toLowerCase();
    const page = parseInt(useQuery().page || '1');
    const [time, setTime] = useState(Date.now());
    const bans = useBans(feedbackCh, community, page, time);

    const [unbanOpen, setUnbanOpen] = useState(false);
    const [targetUser, setTargetUser] = useState('');
    const handleUnban = (author) => {
        setTargetUser(author);
        setUnbanOpen(true);
    }

    const handleClose = () => {
        setUnbanOpen(false);
        setTime(Date.now());
    };

    return (
        <>
            <FixedTopBar back title={'Community Bans'} />
            <WhiteMain className={className}>
                {error && error.toString()}
                {bans && bans.map((ban, i) => (
                    <BanEntry ban={ban} key={i}
                              onClick={() => handleUnban(ban.author) }/>
                ))}
                {bans && bans.length > 0 &&
                    <Pagination path={`?page=`} has_more page={page}/>
                }
            </WhiteMain>
            {unbanOpen && <Sheet onClose={() => handleClose() } padding={"header"}><UnbanSheet community={community} username={targetUser} onClose={() => handleClose() } /></Sheet>}
        </>
    );
})``;

export default Ban;
